var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotelInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1201",
    d: "M0 0h32v32H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1202",
    d: "M25.667 24.333h-1.334V5.667A1.337 1.337 0 0 0 23 4.333h-5.333A1.337 1.337 0 0 0 16.333 3H7a1.337 1.337 0 0 0-1.333 1.333v20H4.333a1.333 1.333 0 1 0 0 2.667h12a1.337 1.337 0 0 0 1.333-1.333V7h4v18.667A1.337 1.337 0 0 0 23 27h2.667a1.333 1.333 0 0 0 0-2.667zm-10.667-8h-2.667v-2.666H15z",
    transform: "translate(1 1)",
    style: {
      fill: "#ea7d36",
      stroke: "#1f0f04"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelInfo);
export default __webpack_public_path__ + "static/media/hotel-info.3a5ee26901caf5dff1230a54dfacab16.svg";
export { ForwardRef as ReactComponent };